import React, { Component } from "react";
import _ from "lodash";
import cx from "classnames";

// material-ui imports
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withStyles } from "@material-ui/core/styles";
import {
  WithStyles,
  createStyles,
  Grid,
  Typography,
  Checkbox,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";
import classNames from "classnames";
import MyPATTextField from './MyPATTextField';
import { debounce } from '../../utils';

// styles
const styles = (theme: Theme) =>
  createStyles({
    dropdownContainer: {
      // zIndex: 2,
      width: "100%",
      position: "relative",
    },
    variationSelect: {
      background: "#FFF !important",
      color: "rgb(102 102 102) !important",
      border: "1px solid #dfdfdf",
      boxSizing: "border-box",
      borderRadius: 30,
      fontSize: "16px",
      padding: "0 12px",
      height: "48px",
      lineHeight: "40px",
      fontFamily: "'Nunito', san-serif",
      boxShadow:'0px 4px 10px 0px rgba(0, 0, 0, 0.05)',
      // cursor: "pointer",
      display: "flex",
      alignItems:'center',
      justifyContent: "space-between",
      "& .selectBox": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        color: '#333',
        // textTransform: 'capitalize'
      },
      '& .lightGrey': {
        color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
         
      }
    },
    dropdownList: {
      zIndex: 9,
      boxShadow: "0px 4px 4px 2px #f1f1f1",
      background: "#FFF !important",
      color: "rgb(102 102 102) !important",
      border: "1px solid #dfdfdf",
      boxSizing: "border-box",
      borderRadius: 4,
      minHeight: "auto",
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "hidden",
      fontFamily: "'Nunito', san-serif",
      textAlign: "left",
      '&::-webkit-scrollbar': {
        width: '4px',
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundcolor: '#b2b2b2',
      },
      "&>div": {
        paddingLeft: "0px",
        width: '100%',
        position: 'relative',
        "& .textfield-box": {
          width: 'calc(100% - 20px)',
          margin: '10px auto 0',
          '& input': {
            padding: '0 25px 0 10px',
          }
        },
        '& .searchCloseIcon': {
          position: 'absolute',
          right: '20px',
          top: '25px',
          cursor: 'pointer',
          '& img': {
            display: 'block',
          }
        }
      },
      position: "absolute",
      top: "40px",
      left: 0,
      width: "100%",
    },
    listItem: {
      fontSize: "16px",
      color: "#666",
      textAlign: "left",
      padding: "12px 14px",
      // cursor: "pointer",
      "&:hover": {
        color: "#333",
        backgroundColor: "#f1f1f1",
      },
    },
    arrowIcon: {
      "&>img": {
        // transform: "rotate(180deg)",
        marginLeft: "43px",
      },
    },
    labelText: {
      marginLeft: "10px",
    },
    checkbox: {
      padding: 0,
      paddingLeft: "10px",
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
        marginRight: "5px",
      },
    },
    errorBorder:{
      border: '1px solid #F21D1D',
      borderRadius: '4px',
    },
    customStyling: {
      borderRadius: 4,
      height: 40,
      minWidth: '178px',
    },
    searchCloseIcon:{
      position: 'absolute',
      cursor: 'pointer',
      right: 10,
      top: 10,
      zIndex: 9
    },
    disabled:{
      '&:nth-child(2)':{
        pointerEvents: 'none',
        opacity: 0.7,
      }
    }
  });

interface MyPATDropDownProps extends WithStyles<typeof styles> {
  classes: any;
  dropdownItems: any[];
  placeholder: string;
  selectedItem: any;
  labelKey?: string;
  valueKey: string;
  error?: boolean;
  errorText?: string;
  disabled?: boolean;
  onChange?: (selectedOption: any) => void;
  multiple?: boolean;
  customwidth?:'';
  customCursor?:'';
  isCustomCss?:boolean;
  isDisabled?:boolean;
  placeHolderTitle?:string;
  enableSearch?: boolean,
  searchPlaceholder?: string,
  handleSearch?: Function,
  onSelectOption?: Function
  onSelectedOption?: (options: any, isSelected?: boolean) => void;
  customSelectedOption?: string;
  fromTestTemplate?: boolean;
}

interface MyPATDropDownState {
  showDropdown: boolean;
  selectedOption: any;
  searchText: string;
  filteredData: any[]
}

class MyPATDropDown extends Component<MyPATDropDownProps, MyPATDropDownState> {
  dropdownPanelRef: any;
  dropdownDisplayRef: any;
  constructor(props: MyPATDropDownProps, state: MyPATDropDownState) {
    super(props);
    this.state = {
      showDropdown: false,
      selectedOption: props.selectedItem || [],
      searchText: '',
      filteredData: props.dropdownItems
    };
        //@ts-ignore
        this.dropdownPanelRef = React.createRef();
        //@ts-ignore
      this.dropdownDisplayRef = React.createRef();
  }

  componentDidMount(): void {
    document.addEventListener('mousedown', this.handleDropdownToggle);
  }
  componentWillUnmount(): void {
    document.removeEventListener('mousedown', this.handleDropdownToggle);
  }


  componentDidUpdate(
    prevProps: MyPATDropDownProps,
    prevState: MyPATDropDownState
  ) {
    const { onChange, multiple, selectedItem,disabled } = this.props;
    const { selectedOption } = this.state;

    if (JSON.stringify(prevProps.selectedItem) !== JSON.stringify(selectedItem)) {
      if (multiple && prevProps.selectedItem.length === selectedItem.length && !selectedItem.length) {
        return;
      }
      this.setState({
        selectedOption: selectedItem,
      });
    }

    if (JSON.stringify(prevState.selectedOption) !== JSON.stringify(selectedOption) && onChange && !disabled) {
      onChange(selectedOption);
    }
  }

  handleDropdownToggle = (event: any) => {
    const { showDropdown, searchText } = this.state;
    if (this.dropdownPanelRef.current && this.dropdownPanelRef.current.contains(event.target)) {
      return;
    }
    const dropdownOpenConditions = [!showDropdown, !this.props.disabled, this.dropdownDisplayRef.current && this.dropdownDisplayRef.current.contains(event.target)];
    if (dropdownOpenConditions.every(Boolean)) {
      this.openDropDown();
      return;
    }
    showDropdown && this.setState({ filteredData: this.props.dropdownItems, searchText: this.props.handleSearch ? searchText : '' });
    this.closeDropDown(event);
  }

  closeDropDown = (event: any) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showDropdown: false,
      };
    });
  };

  openDropDown = () => {
    this.setState((prevState) => {
      if (!prevState.showDropdown) {
        return {
          ...prevState,
          showDropdown: true,
        };
      }
      return prevState;
    });
  };

  handleOption = (selectedOption: any) => {
    const { multiple, valueKey } = this.props;
    this.setState((prevState) => {
      let isOptionSelected = true;
      let newSelectedOption = prevState.selectedOption;
      if (multiple) {
        const filtered = newSelectedOption.filter(
          (option: any) => option !== selectedOption[valueKey]
        );
        if (
          newSelectedOption.length === 0 ||
          filtered.length === newSelectedOption.length
        ) {
          // the option is not present so add it
          newSelectedOption = newSelectedOption.concat(
            selectedOption[valueKey]
          );
        } else {
          newSelectedOption = filtered;
          isOptionSelected = false;
        }
      } else {
        newSelectedOption = selectedOption;
      }
      this.props.onSelectedOption && this.props.onSelectedOption(selectedOption, isOptionSelected);

      return {
        ...prevState,
        selectedOption: newSelectedOption,
        showDropdown: multiple,
      };
    });
    
    if (this.props.onSelectOption) {
      this.props.onSelectOption(selectedOption);
    }
  };

  extractDisplayValue = (option: any) => {
    const { labelKey, dropdownItems, valueKey } = this.props;
    const data = dropdownItems.find((item) => item[valueKey] === option);

    if (labelKey && data) {
      return data[labelKey];
    }
    return option;
  };

  renderSelectedOption = () => {
    const { multiple, placeholder,valueKey } = this.props;
    const { selectedOption } = this.state;
    if (selectedOption && !_.isEmpty(selectedOption)) {
      if (multiple && !_.isEmpty(selectedOption)) {
        return selectedOption
          .map((option: any) => this.extractDisplayValue(option))
          .join(", ");
      }
      return this.extractDisplayValue(typeof(selectedOption)==='object'?selectedOption[valueKey]:selectedOption);
    }
    return placeholder;
  };

  debouncedHandleSearch = debounce((value: string) => {
    if (this.props.handleSearch) {
      this.props.handleSearch(value);
    } else {
      const filteredData = this.props.dropdownItems.filter(item => {
        let label = item;
        if (typeof(item) === 'object' && this.props.labelKey) {
          label = item[this.props.labelKey];
        }
        return (label || '').toLowerCase().includes((value || '').toLowerCase());
      });
      this.setState({ filteredData });
    }
  }, 300);

  handleSearch = (event: any) => {
    const searchText = (event.target.value || '').trimLeft();
    this.setState({ searchText });
    this.debouncedHandleSearch(searchText);
  }
  render() {
    const {
      classes,
      dropdownItems,
      labelKey,
      multiple,
      valueKey,
      error,
      errorText,
      disabled,
      isCustomCss=false,
      isDisabled=false,
      customwidth="500px",
      customCursor='no-drop',
      customSelectedOption = '',
      placeHolderTitle,
      enableSearch,
      searchPlaceholder,
      fromTestTemplate = false,
    } = this.props;

    const { showDropdown, selectedOption, filteredData } = this.state;
    const optionList = this.props.handleSearch ? dropdownItems : filteredData;

    return (
      <>
        <Grid className={classNames(classes.dropdownContainer, "dropdownBox",{[classes.disabled]:disabled})}>
          <Grid className={classes.customDropdown}
           tabIndex={isDisabled?-1:0}>
            <div
              className={classNames(classes.variationSelect, error && classes.errorBorder, fromTestTemplate && classes.customStyling)}
              style={{cursor: isDisabled?customCursor:'pointer'}}
              ref={this.dropdownDisplayRef}
             
            >
              <span className={(_.isEmpty(this.state.selectedOption)) ? 
              "lightGrey" : (this.state.selectedOption != '') ? 
               "selectBox" : ''}
              style={{ maxWidth: isCustomCss?customwidth:'280px'}}
              >
                {customSelectedOption || this.renderSelectedOption()}
              </span>
              <span className={classes.arrowIcon}>
                {/* <img src="/assets/svg/userManagement/arrowUP.svg" /> */}
                <img src="/assets/svg/dropdown-arrow.svg" />
              </span>
            </div>
            {error && (
              <Typography
                className={classes.errorText}
                variant="caption"
                color="error"
              >
                <Error /> {errorText}
              </Typography>
            )}
            {showDropdown && (
              <div ref={this.dropdownPanelRef}>
                <Grid className={classes.dropdownList + ' dropDownlisting'} container>
                  {enableSearch && 
                    <div>
                      <MyPATTextField
                        placeholder={searchPlaceholder}
                        value={this.state.searchText}
                        onChange={this.handleSearch}
                        fullWidthControl
                        autoFocus
                        className="textfield-box"
                      />
                      {this.state.searchText && <span className={cx(classes.searchCloseIcon, "searchCloseIcon")}>
                        <img src="assets/svg/course-plan-request/search-close.svg" alt="Search Close" onClick={this.handleSearch} />
                      </span>}
                    </div>
                  }
                  {optionList.map((item: any, i) => {
                    // const label = typeof item === 'string' ? item : item[labelKey];
                    let label = item;
                    if (typeof item === "object") {
                      if (labelKey) {
                        label = item[labelKey];
                      }
                    }
                    const isSelected =
                      multiple &&
                      selectedOption.find(
                        (option: any) => option === item[valueKey]
                      );

                    return (
                      <Grid
                        item
                        xs={12}
                        key={i}
                        className={classes.listItem + ' listingItem'}
                        style={{cursor: isDisabled?customCursor:'pointer'}}
                        onClick={(e) => this.handleOption(item)}
                        alignItems="center"
                      >
                        <Grid container>
                          {multiple && (
                            <Grid item xs="auto">
                              <Checkbox
                                classes={{
                                  root: classes.checkbox + ' checkboxPl0',
                                  checked:'checkdCheckbox',
                                }}
                                checked={!!isSelected}
                                value={multiple ? item[valueKey] : item}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.handleOption(item)
                                }}
                                color="primary"
                              />
                            </Grid>
                          )}
                          <Grid item xs className={classes.labelText + ' checkboxText'}>
                            {placeHolderTitle && <div>{placeHolderTitle}</div>}
                           <div>{label} </div>   
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </div>
            )}
          </Grid>
        </Grid>
      </>
    );
  }
}
// @ts-ignore
export default withStyles(styles)(MyPATDropDown);
